export const frontmatter = {
  title: "SCALE Emissions",
  date: "2025-09-21",
  description: "SCALE Emissions",
  category: "scale liquidity",
}

Update with the emissions data

TODO: Replace E-Charts code with MDX chart components
The following section contains E-Charts JavaScript code that will be replaced
with custom MDX chart components in the future.
